import { render } from "./DashboardCoreOverview.vue?vue&type=template&id=83a7cf26&scoped=true"
import script from "./DashboardCoreOverview.vue?vue&type=script&lang=js"
export * from "./DashboardCoreOverview.vue?vue&type=script&lang=js"

import "./DashboardCoreOverview.vue?vue&type=style&index=0&id=83a7cf26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83a7cf26"]])

export default __exports__